import { useState, useEffect } from "react";
import CountUp from "react-countup";
import { motion } from "framer-motion";

const metrics = [
  {
    label: "Study Materials Mastered",
    value: 1200,
    suffix: "+",
    variant: "light" as const,
  },
  {
    label: "Study Sessions Completed",
    value: 80,
    suffix: "+",
    variant: "dark" as const,
  },
  {
    label: "of Students Learn Faster",
    value: 95,
    suffix: "%",
    variant: "light" as const,
  },
  {
    label: "Personalized Flashcard Sets Created",
    value: 2500,
    suffix: "+",
    variant: "dark" as const,
  },
  {
    label: "Average Score Improvement",
    value: 60,
    suffix: "%",
    variant: "light" as const,
  },
  {
    label: "Study at 2am. We're Always Here.",
    value: 24,
    suffix: "/7",
    variant: "dark" as const,
  },
];

export const Metrics = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);
  return (
    <section className="w-full py-24 bg-foreground">
      <div className="container mx-auto text-center">
        {/* Section Title */}
        <h2 className="text-4xl leading-none text-primary-foreground text-center font-medium md:text-6xl mb-16">
          Real Students. Real Results.
        </h2>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {metrics.map((metric, index) => (
            <motion.div
              key={index}
              className={`rounded-2xl p-7 flex flex-col items-center gap-4 ${
                metric.variant === "light" ? "bg-muted" : "bg-primary-foreground/5"
              }`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
            >
              <div className="flex items-center gap-1.5 font-medium">
                <h3
                  className={`text-[3.38rem] leading-none ${
                    metric.variant === "light" ? "text-foreground" : "text-primary-foreground"
                  }`}
                >
                  {mounted ? (
                    <CountUp start={0} end={metric.value} duration={3.5} separator="," />
                  ) : (
                    <span>0</span>
                  )}
                </h3>
                <p
                  className={`text-[3.5rem] leading-none ${
                    metric.variant === "light" ? "text-foreground" : "text-primary-foreground"
                  }`}
                >
                  {metric.suffix}
                </p>
              </div>
              <p
                className={`font-semibold text-xl text-center ${
                  metric.variant === "light" ? "text-foreground" : "text-primary-foreground"
                }`}
              >
                {metric.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
